import React from "react";
import { Button, Icon, Toast } from "antd-mobile";
import { post } from "../../../utils/request";
import { href } from "../../../utils/util";

import "./index.less";

var timer;
class AttestationStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      second: 5,
      secondType: false,
    };
  }

  componentWillReceiveProps(prevProps) {
    clearInterval(timer);
    if (prevProps.status === "loading") {
      this.timeFN();
    }
  }

  timeFN = () => {
    let _this = this;
    clearInterval(timer);
    this.setState(
      {
        second: 5,
      },
      () => {
        let { second } = this.state;
        timer = setInterval(() => {
          if (second < 0) {
            clearInterval(timer);
            this.props.onQuit("error"); //临时-============================
          } else {
            _this.setState({
              second: second--,
            });
          }
        }, 1000);
      }
    );
  };

  render() {
    let { iconType, second } = this.state;
    return (
      <div className="AttestationStatusBox">
        {this.props.status ? (
          <div>
            {this.props.status === "error" ? (
              <div className="error">
                <div>
                  <Icon type="cross-circle-o" size="lg" />
                  <span>认证失败</span>
                </div>
                <Button
                  type="primary"
                  onClick={() => {
                    this.props.onQuit("");
                  }}
                >
                  重新认证
                </Button>
              </div>
            ) : (
              ""
            )}
            {this.props.status === "success" ? (
              <div className="success">
                <div>
                  <Icon type="check-circle" size="lg" />
                  <span>认证成功</span>
                  <p>您已成功完成实名认证！</p>
                </div>
                <Button
                  type="primary"
                  onClick={() => {
                    window.location.href = "";
                  }}
                >
                  前往签署
                </Button>
              </div>
            ) : (
              ""
            )}
            {this.props.status === "loading" ? (
              <div className="loading">
                <div>
                  <i></i>
                  <span>实名认证中</span>
                  <p>
                    请耐心等待 <span>{second}</span> 秒
                  </p>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}

export default AttestationStatus;



// WEBPACK FOOTER //
// ./src/identityVerification/modules/attestationStatus/index.js